import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  tipoCriticidad: null,
  tipoCriticidadError: "",
  formError: "",
};

export default function TipoCriticidadReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_TIPO_CRITICIDAD:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_TIPO_CRITICIDAD:
      return { ...state, saveLoading: action.payload };
    case actions.GET_TIPO_CRITICIDAD:
      return { ...state, tipoCriticidad: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.TIPO_CRITICIDAD_FAIL:
      return { ...state, tipoCriticidadError: action.payload };
    default:
      return state;
  }
}
